<template>

  <div>
    <el-dialog
      title="Términos y Condiciones"
      :visible.sync="centerDialogVisible"
      width="80%"
      style="margin-top: -12vh; height: auto; overflow-y:hidden"
      :lock-scroll="true">
      <div style=" max-height: 60vh; overflow:auto">
        <p>{{ configuration }}</p><br><br>
      </div>
      <form @submit.prevent="">
      <div>
        <input type="checkbox" name="aceptoTerminos" required style="width: 15px; float: left; margin-right:5px" v-model="checked">Acepto los términos y condiciones del sitio</div>
      <div>
        <input type="checkbox" name="aceptoCodigoEtica" required style="width: 15px; float: left; margin-right:5px" v-model="checked2">
        Acepto el <a target="_blank" rel="noopener noreferrer" :href="codigoEtica">código de ética</a> para proveedores de contreras.
      </div>
      <span slot="footer" class="dialog-footer">
        <button type="submit" v-on:click="submitFormSolicitud()" :disabled="!checked2 || !checked"  v-bind:class="'btn btn-primary btn-lg ' + loading" style="position:relative; left:45%">Aceptar</button>
      </span>
      </form>
    </el-dialog>

    <h1 class="text-center" v-if="!paramError">Pedido de usuario nuevo del Portal</h1>
    <p class="text-center" v-if="!paramError"> Para solicitar un usuario nuevo del portal, es necesario validar su identidad y la de su empresa. Por favor complete los siguientes datos:</p>
    <section class="content">
    <div class="row" v-if="paramError">
        <div class="col-md-12 text-center">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
              <div class="info-box ">
                <span class="info-box-icon bg-red"><i class="ion ion-android-alert"></i></span>
                <div class="info-box-content">
                  <span class="info-box-text">Advertencia</span>
                  <span class="info-box-info">{{paramError}}</span>
                </div>
                <!-- /.info-box-content -->
              </div>
            <!-- /.info-box -->
          </div>
        </div>
      </div>
      <div class="row" v-if="!paramError">
        <div class="col-md-12">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">Datos de la Compañia</h3>
            </div>
            <div class="box-body">
              <form class="ui form solicitudForm" id="formSolicitud" @submit.prevent="submitFormSolicitud()">
                  <div class="row">
                    <div class="col-xs-10 col-sm-6 col-md-4 col-lg-4">
                      <div class="group">
                        <masked-input :mask="cuitMask" :guide="false" v-model="rut" placeholder="" type="text" required/>
                        <label>CUIT de la compañia</label>
                      </div>
                    </div>
                  </div>
                  <h4 v-if="!paramInvoices">Datos últimas 3 facturas</h4>
                  <div class="row entradas" v-if="!paramInvoices">
                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="input-group entradas_min">
                          <span class="input-group-addon">
                              <i class="fas fa-sort-numeric-asc" aria-hidden="true"></i>
                          </span>
                          <masked-input :mask="invoiceMask" :guide="false" class="form-control" name="invoice0" v-model="invoice0" placeholder="Nro factura 1"  type="text" required/>
                        </div>
                      </div>

                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                          <div class="input-group entradas_min">
                            <span class="input-group-addon">
                                <i class="fa fa-fw fa-calendar"></i>
                            </span>
                            <input class="form-control col-md-12" type="date" format="DDMMYYYY" name="date0" id="date0" v-model="date0" required ></input>
                          </div>
                      </div>
                  </div>
                  <div class="row entradas" v-if="!paramInvoices">
                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="input-group entradas_min">
                          <span class="input-group-addon">
                            <i class="fa fa-sort-numeric-asc" aria-hidden="true"></i>
                          </span>
                          <masked-input :mask="invoiceMask" :guide="false" class="form-control" name="invoice1" v-model="invoice1" placeholder="Nro factura 2" type="text" required/>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="input-group entradas_min">
                            <span class="input-group-addon">
                              <i class="fa fa-fw fa-calendar"></i>
                            </span>
                          <input class="form-control col-md-12" type="date" format="DDMMYYYY" name="date1" id="date1" v-model="date1" required ></input>
                        </div>
                      </div>
                  </div>
                  <div class="row entradas" v-if="!paramInvoices">
                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                          <div class="input-group entradas_min">
                            <span class="input-group-addon">
                              <i class="fa fa-sort-numeric-asc" aria-hidden="true"></i>
                            </span>
                            <masked-input :mask="invoiceMask" :guide="false" class="form-control" name="invoice2" v-model="invoice2" placeholder="Nro factura 3" type="text" required/>
                          </div>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                          <div class="input-group entradas_min">
                            <span class="input-group-addon">
                              <i class="fa fa-fw fa-calendar"></i>
                            </span>
                            <input class="form-control col-md-12" type="date" format="DDMMYYYY" name="date2" id="date2" v-model="date2" required ></input>
                          </div>
                      </div>
                  </div>
                  <h4>Nombre y Apellido</h4>
                  <div class="input-group entradas_min">
                    <span class="input-group-addon">
                      <i class="fa fa-user" aria-hidden="true"></i>
                    </span>
                    <input class="form-control" name="name" v-model="name" placeholder="Nombre y Apellido" type="text" required>
                  </div>

                  <h4>Motivo </h4>
                  <div class="input-group entradas_min">
                    <span class="input-group-addon">
                      <i class="far fa-sticky-note" aria-hidden="true"></i>
                    </span>
                    <input class="form-control" name="reason" v-model="reason" placeholder="Motivo del pedido de alta de usuario" type="text">
                  </div>
                  <h4>Correo electrónico </h4>
                  <div class="input-group entradas_min">
                    <span class="input-group-addon">
                      <i class="far fa-envelope" aria-hidden="true"></i>
                    </span>
                    <input class="form-control" name="email" v-model="email" placeholder="Correo electrónico" type="email" required>
                  </div>
                  <br><br/>
                  <div class="input-group entradas_min" >
                    <vue-recaptcha @verify="captchaVerificado()" :sitekey="siteKey" :loadRecaptchaScript="true"></vue-recaptcha>
                  </div>
                  <div class="col-md-12 text-center" >
                    <button type="submit" :disabled="!captcha" v-bind:class="'btn btn-primary btn-lg ' + loading"> Enviar solicitud</button>
                  </div>
              </form>
            </div>
            <div class="row">
        <div class="col-md-12 text-center" v-if="response" style="margin-top: 5px">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
              <div class="info-box ">
                <span class="info-box-icon bg-yellow"><i class="ion ion-android-alert"></i></span>
                <div class="info-box-content">
                  <span class="info-box-info">{{response}}</span>
                </div>
              </div>
          </div>
        </div>
        <div class="col-md-12 text-center" v-if="success" style="margin-top: 5px">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
              <div class="info-box ">
                <span class="info-box-icon bg-green"><i class="ion ion-android-checkmark-circle"></i></span>
                <div class="info-box-content">
                  <span class="info-box-info">{{success}}</span>
                </div>
                <!-- /.info-box-content -->
              </div>
            <!-- /.info-box -->
          </div>
        </div>
      </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
require('moment')
import datepicker from 'vue-date-picker'
import MaskedInput from 'vue-text-mask'
import api from '../../api'
import TheMask from 'vue-the-mask'
import VueRecaptcha from 'vue-recaptcha'
import gRecaptcha from './recaptcha'

export default {
  name: 'Solicitud',
  components: {datepicker, TheMask, MaskedInput, VueRecaptcha, gRecaptcha},
  computed: {
    datetime () {
      return new Date()
    }
  },
  data (router) {
    return {
      captcha: false,
      checked2: false,
      section: 'Solicitud',
      loading: '',
      rut: '',
      configuration: '',
      codigoEtica: '',
      invoice0: '',
      date0: '',
      invoice1: '',
      date1: '',
      invoice2: '',
      date2: '',
      name: '',
      reason: '',
      email: '',
      response: null,
      success: null,
      paramError: null,
      paramInvoices: null,
      rutMask: this.$store.state.rutMask,
      cuitMask: [/[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
      invoiceMask: this.$store.state.invoiceMask,
      centerDialogVisible: false,
      checked: false,
      siteKey: '6LdsJtEUAAAAAKYTuuM3rWVyttE2EuQzwMp_ZwnO'
    }
  },
  methods: {
    captchaVerificado () {
      this.captcha = true
    },
    submitFormSolicitud () {
      if (this.checked2 === true && this.checked === true) {
        this.centerDialogVisible = false
        this.checkData()
      } else {
        this.checked2 = false
        this.checked = false
        this.centerDialogVisible = true
      }
    },
    clearInput (vueModel) {
      vueModel = ''
    },
    checkData () {
      if (this.rut.length !== 11) {
        this.$message({
          message: 'El CUIT debe tener 11 caracteres.',
          type: 'warning'
        })
        return
      }
      const {rut, invoice0, date0, invoice1, date1, invoice2, date2, name, reason, email} = this
      this.toggleLoading()
      this.resetResponse()
      this.$store.commit('TOGGLE_LOADING')

      /* Making API call to authenticate a user */
      api.request('GET', 'api/solicitudUsuario' + '?rut=' + rut + '&invoice0=' + invoice0 + '&date0=' + date0 + '&invoice1=' + invoice1 + '&date1=' + date1 + '&invoice2=' + invoice2 + '&date2=' + date2 + '&name=' + name + '&reason=' + reason + '&email=' + email)
        .then(response => {
          this.toggleLoading()

          var data = response.data
          /* Checking if error object was returned from the server */
          if (response.data.error) {
            var errorName = response.data.error.name
            if (errorName) {
              console.log(errorName)
              this.checked = false
              this.checked2 = false
              if (errorName === 'InvalidArgumentError') {
                this.response = 'Los datos son incorrectos.'
              } else if (errorName === 'NotFoundError') {
                this.response = 'se ha producido un error inesperado.'
              } else {
                this.response = errorName
              }
            } else {
              this.response = data.error
            }

            return
          } else {
            if (data.success) {
              this.success = data.success
              this.clearFields()
            }
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          this.invoices = null
          console.log(error)

          this.response = 'Error al conectarse con el servidor, contacte al administrador.'
          this.toggleLoading()
        })
    },
    toggleLoading () {
      this.loading = (this.loading === '') ? 'cargando' : ''
    },
    resetResponse () {
      this.response = ''
      this.success = ''
    },
    clearFields () {
      this.name = ''
      this.rut = ''
      this.reason = ''
      this.email = ''
      this.checked = false
      this.checked2 = false
    }
  },
  beforeMount () {
    window.localStorage.removeItem('token')
    api.request('get', 'api/checkParam?id=SUN-001')
      .then(response => {
        var data = response.data
        console.log(data.error)

        if (data.error) {
          this.paramError = data.error
        }
      })
      .catch(error => {
        console.log(error)
      })
    api.request('get', 'api/findConfiguration/TYC')
      .then(response => {
        this.configuration = response.data['value']
      })
      .catch(error => {
        console.log(error)
      })
    api.request('get', 'api/findConfiguration/CODETI')
      .then(response => {
        this.codigoEtica = response.data['value']
      })
      .catch(error => {
        console.log(error)
      })
    api.request('get', 'api/checkParam?id=SUF-001')
      .then(response => {
        var data = response.data

        if (data.error) {
          this.paramInvoices = data.error
        }
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>

<style>
.datetime-picker input {
  height: 4em !important;
}


.entradas {
  padding:5px 2px 5px 2px;
}

.entradas_min {
  padding:1px 1px 5px 1px;
}


/*----------PAPER-----------*/
/* form starting stylings ------------------------------- */
.group        {
  position:relative;
  margin-bottom:45px;
}
input         {
  font-size:18px;
  padding:10px 10px 10px 5px;
  display:block;
  width: 100%;
  border:none;
  border-bottom:1px solid #757575;
}
input:focus     { outline:none; }

/* LABEL ======================================= */
label          {
  color:#999;
  font-size:18px;
  font-weight:normal;
  position:absolute;
  pointer-events:none;
  left:5px;
  top:10px;
  transition:0.2s ease all;
  -moz-transition:0.2s ease all;
  -webkit-transition:0.2s ease all;
}

/* active state */
input:focus ~ label, input:valid ~ label    {
  top:-20px;
  font-size:14px;
  color:#5264AE;
}

/* BOTTOM BARS ================================= */
.bar  { position:relative; display:block; width:100%; }
.bar:before, .bar:after   {
  content:'';
  height:2px;
  width:0;
  bottom:1px;
  position:absolute;
  background:#5264AE;
  transition:0.2s ease all;
  -moz-transition:0.2s ease all;
  -webkit-transition:0.2s ease all;
}
.bar:before {
  left:50%;
}
.bar:after {
  right:50%;
}

/* active state */
input:focus ~ .bar:before, input:focus ~ .bar:after {
  width:50%;
}



/* HIGHLIGHTER ================================== */
.highlight {
  position:absolute;
  height:60%;
  width:100px;
  top:25%;
  left:0;
  pointer-events:none;
  opacity:0.5;
}

/* active state */
input:focus ~ .highlight {
  -webkit-animation:inputHighlighter 0.3s ease;
  -moz-animation:inputHighlighter 0.3s ease;
  animation:inputHighlighter 0.3s ease;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
    -moz-appearance:textfield; /* Firefox */
}

/* ANIMATIONS ================ */
@-webkit-keyframes inputHighlighter {
  from { background:#5264AE; }
  to  { width:0; background:transparent; }
}
@-moz-keyframes inputHighlighter {
  from { background:#5264AE; }
  to  { width:0; background:transparent; }
}
@keyframes inputHighlighter {
  from { background:#5264AE; }
  to  { width:0; background:transparent; }
}

</style>



// WEBPACK FOOTER //
// Solicitud.vue?4d08cb0b